import { defineComponent, ref, onMounted } from 'vue';
export default defineComponent({
  props: {
    length: {
      type: Number,
      default: 6
    },
    type: {
      type: String,
      default: 'number'
    },
    inputMode: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'lg'
    }
  },
  setup: (props, {
    emit
  }) => {
    const otpValue = ref('');
    const otpInput = ref();
    const onInput = value => {
      otpValue.value = value;
      emit('onChange', value);
      handleInputValue(value);
    };
    const handleInputValue = value => {
      const {
        length
      } = props;
      if (value.length >= length) {
        emit('complete', value.slice(0, length));
      }
    };
    const resetOtp = () => {
      otpValue.value = '';
      otpInput.value.$el.querySelectorAll('input')[0].focus();
    };
    onMounted(() => {
      setTimeout(() => {
        otpInput.value.$el.querySelectorAll('input')[0].focus();
      }, 50);
    });
    return {
      onInput,
      otpValue,
      resetOtp,
      otpInput
    };
  }
});